import MovingBorderMenu from "../Menu/MovingBorderMenu";

class OPDSettings {

    constructor() {
        this.settingsSecondaryMenu = new MovingBorderMenu('.opd-settings-secondary-menu');
    }

}

export default OPDSettings;


// WEBPACK FOOTER //
// ./resources/assets/js/Pages/Settings.js